const HeaderContainer = ({ children }) => {
  return <div className="max-w-[1250px] mx-auto ">{children}</div>;
};

export default HeaderContainer;
